import { Options, Vue } from 'vue-class-component';
import BadgeItem from '../../BadgeItem/BadgeItem.vue';
import {
  ApartmentDTO,
  BadgeDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'AddBadgePage',
  props: {
    plantBadges: {
      type: Object as PropType<BadgeDTO[]>,
      required: true,
    },
    badgesList: {
      type: Object as PropType<BadgeDTO[]>,
      required: true,
    },
    gateGuest: {
      type: Object as PropType<GateGuestDTO>,
      required: false,
      default: null,
    },
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: false,
      default: null,
    },
  },
  components: {
    BadgeItem,
  },
  watch: {
    badgeCode: function (newValue) {
      this.verifyValidityOfCode(newValue);
    },
  },
  emits: ['add-badge', 'remove-badge'],
})
export default class AddBadgePage extends Vue {
  plantBadges!: BadgeDTO[];
  badgesList!: BadgeDTO[];
  apartment!: ApartmentDTO;
  gateGuest!: GateGuestDTO;
  badgeCode: string = '';
  isValidCode = true;
  invalidCodeReason = '';

  get addButtonDisabled() {
    const codeNotValid = !this.isValidCode || this.badgeCode?.trim().length < 8;
    if (this.gateGuest) {
      const guestHasAlreadyBadge = this.badgesList.some(
        (badge) => badge.gateGuest?.id === this.gateGuest.id
      );
      return codeNotValid || guestHasAlreadyBadge;
    }
    if (this.apartment) {
      //check if apartement badges plus the added badges for the apartement are 10 or more
      const apartmentExistingBadges = this.apartment.badgeList?.length || 0;
      const apartmentAddedBadges = this.badgesList.filter(
        (badge) => badge.apartment?.apartmentId === this.apartment.apartmentId
      ).length;
      const apartmentTotalBadges = apartmentExistingBadges + apartmentAddedBadges;

      if (apartmentTotalBadges >= 10) {
        this.invalidCodeReason = this.$t('entrancePlant.popupMessageMaxBadgesReachedWarning');
      }
      return codeNotValid || apartmentTotalBadges >= 10;
    }
  }

  get noBadgeText() {
    const textToSplit = this.$t('AppResourceEP.BadgesListEmptyMessage');
    const noBadgeTextLines = textToSplit.split('\n');
    return noBadgeTextLines;
  }

  addBadge() {
    const addedBadge: BadgeDTO = new BadgeDTO({
      badgeCode: this.badgeCode,
      gateGuest: this.gateGuest,
      apartment: this.apartment,
    });
    this.$emit('add-badge', addedBadge);
    this.badgeCode = '';
  }

  removeBadge(badgeToRemove: BadgeDTO) {
    this.$emit('remove-badge', badgeToRemove);
  }

  async verifyValidityOfCode(codeToCheck: string) {
    this.badgeCode = codeToCheck.toUpperCase().trim();
    
    if (codeToCheck.length === 8) {
    const hexRegex = new RegExp("^[A-F0-9]{8}$");
    const hexValid = hexRegex.test(this.badgeCode);
    
      const alreadyExisting = this.plantBadges.some(
        (plantBadge) =>
          plantBadge.badgeCode?.toLowerCase().trim() ===
        this.badgeCode?.toLowerCase().trim()
      );
      
      const alreadyAdded = this.badgesList.some(
        (addedBadge) =>
          addedBadge.badgeCode?.toLowerCase().trim() ===
        this.badgeCode?.toLowerCase().trim()
      );
      
      this.isValidCode = hexValid && !alreadyExisting && !alreadyAdded;
      if (!hexValid) {
        this.invalidCodeReason = this.$t('AppResourceEP.InputNotValid');
      } else {
        this.invalidCodeReason = this.isValidCode
        ? ''
        : this.$t('general.alreadyExisting');
      }
    } else {
      this.isValidCode = true;
      this.invalidCodeReason = '';
    }
  }
}
